import { useEffect, useState } from "react";

const useIsTablet = (): boolean => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < 1024 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initialize

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

export default useIsTablet;
